<template>
  <v-layout :align-center="center" :class="`app-info ${classes}`">
    <v-flex
      shrink
      :style="labelStyles"
      class="font-weight-bold pr-1"
      :class="[componentClass, { caption: isCaption }]"
    >
      {{ label }}
    </v-flex>
    <v-flex :class="componentClass" class="body-2 app-info--text">
      <slot></slot>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    center: { type: Boolean, default: true },
    componentClass: { type: String, default: null },
    label: { type: String, default: null },
    labelWidth: { type: Number, default: 100 },
    isCaption: { type: Boolean, default: true },
    classes: { type: String, default: 'mb-1' }
  },
  computed: {
    labelStyles() {
      return {
        width: `${this.labelWidth}px`,
        minWidth: `${this.labelWidth}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-info {
  min-height: 28px;
}
.app-info--text {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
